import React, { useState } from 'react';
import './Notifications.css';

function Notifications() {
  const [notifications, setNotifications] = useState([
    { id: 1, type: 'success', title: 'Entry Confirmed', message: 'You entered the Discord Nitro giveaway', time: '2 minutes ago', read: false },
    { id: 2, type: 'info', title: 'New Giveaway', message: 'A new giveaway has started!', time: '1 hour ago', read: false },
    { id: 3, type: 'warning', title: 'Entry Expiring', message: 'Your entry expires in 2 days', time: '3 hours ago', read: true },
    { id: 4, type: 'success', title: 'Boost Activated', message: 'Your 2x entry boost is now active', time: '1 day ago', read: true },
    { id: 5, type: 'info', title: 'Announcement', message: 'New features have been added!', time: '2 days ago', read: true },
  ]);

  const unreadCount = notifications.filter(n => !n.read).length;

  const markAsRead = (id) => {
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const deleteNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  return (
    <div className="notifications-page">
      <div className="notifications-container">
        <div className="notifications-header">
          <h1>🔔 Notifications</h1>
          {unreadCount > 0 && (
            <div className="unread-badge">{unreadCount} unread</div>
          )}
          {unreadCount > 0 && (
            <button className="mark-all-read" onClick={markAllAsRead}>
              Mark all as read
            </button>
          )}
        </div>

        <div className="notifications-list">
          {notifications.length === 0 ? (
            <div className="empty-notifications">
              <p>No notifications</p>
            </div>
          ) : (
            notifications.map(notification => (
              <div
                key={notification.id}
                className={`notification-item ${notification.read ? 'read' : 'unread'} type-${notification.type}`}
              >
                <div className="notification-icon">
                  {notification.type === 'success' && '✅'}
                  {notification.type === 'info' && 'ℹ️'}
                  {notification.type === 'warning' && '⚠️'}
                  {notification.type === 'error' && '❌'}
                </div>
                <div className="notification-content">
                  <h3>{notification.title}</h3>
                  <p>{notification.message}</p>
                  <span className="notification-time">{notification.time}</span>
                </div>
                <div className="notification-actions">
                  {!notification.read && (
                    <button
                      className="action-btn"
                      onClick={() => markAsRead(notification.id)}
                      title="Mark as read"
                    >
                      ✓
                    </button>
                  )}
                  <button
                    className="action-btn delete"
                    onClick={() => deleteNotification(notification.id)}
                    title="Delete"
                  >
                    ×
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Notifications;

